import { render, staticRenderFns } from "./modaldeductionpayroll.vue?vue&type=template&id=03d83ee6"
import script from "./modaldeductionpayroll.vue?vue&type=script&lang=js"
export * from "./modaldeductionpayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports